import { call, put, takeLatest } from "redux-saga/effects";
import { AuthAPI, ProfileAPI } from "./api";
import {
  loginRequested, loginSucceeded, loginFailed,
  registerRequested, registerSucceeded, registerFailed,
  updateRequested, updateSucceeded, updateFailed,
  verifyUserRequested, verifyUserSucceeded, verifyUserFailed,
  resetPasswordRequested, resetPasswordSucceeded, resetPasswordFailed,
} from "./slice";

function* loginWorker({ payload }) {
  try {
    const { token, user } = yield call(AuthAPI.login, payload);
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));
    yield put(loginSucceeded({ token, user }));
  } catch (e) {
    yield put(loginFailed(e?.message || "로그인 실패"));
  }
}

function* registerWorker({ payload }) {
  try {
    yield call(AuthAPI.register, payload);
    yield put(registerSucceeded());
  } catch (e) {
    yield put(registerFailed(e?.message || "회원가입 실패"));
  }
}

function* updateWorker({ payload }) {
  try {
    const updated = yield call(ProfileAPI.updateUser, payload);
    yield put(updateSucceeded({ user: updated || null }));
  } catch (e) {
    yield put(updateFailed(e?.message || "회원정보 수정 실패"));
  }
}

function* verifyUserWorker({ payload }) {
  try {
    const resetToken = yield call(AuthAPI.verifyForgotPassword, payload);
    yield put(verifyUserSucceeded(resetToken));
  } catch (e) {
    yield put(verifyUserFailed(e?.message || "일치하는 회원 정보가 없습니다."));
  }
}

function* resetPasswordWorker({ payload }) {
  try {
    yield call(AuthAPI.resetPassword, payload);
    yield put(resetPasswordSucceeded());
  } catch (e) {
    yield put(resetPasswordFailed(e?.message || "비밀번호 변경 실패"));
  }
}

export default function* authSaga() {
  yield takeLatest(loginRequested.type, loginWorker);
  yield takeLatest(registerRequested.type, registerWorker);
  yield takeLatest(updateRequested.type, updateWorker);
  yield takeLatest(verifyUserRequested.type, verifyUserWorker);
  yield takeLatest(resetPasswordRequested.type, resetPasswordWorker);
}
